<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="800"
  [height]="utilsSvc.getWindowAvailableHeight(150)"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>

  <form [formGroup]="form">
    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <yo-lookup
          #siteLookup
          [data]="findAllLocalSites()"
          [selectedItem]="idSelectedSite"
          autoSelect="false"
          [placeholder]="sitePlaceholder"
          (onValueChange)="onChangeSite($event)"
          [disabled]="!canModify() || gefConnection?.id != null"
        ></yo-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Interface">Interface <span class="danger-color">*</span></div>
      <div class="value">
        <yo-lookup
          #gefProvidersLookup
          [data]="gefProviders"
          [placeholder]="'Sélectionner un connecteur GEF'"
          [selectedItem]="idSelectedGefProvider"
          (onValueChange)="onChangeGefProvider($event)"
          [disabled]="!canModify() || gefConnection?.id != null"
        ></yo-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label text-nowrap" title="Abonnement flux">Abonnement flux</div>
      <div class="value">
        <yo-tagbox
          [data]="fluxList"
          [selectedItems]="selectedFlux"
          (onValueChange)="onSelectedFluxChange($event)"
          [disabled]="!canModify()"
        >
        </yo-tagbox>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Actif">Actif <span class="danger-color">*</span></div>
      <div class="value">
        <dx-check-box
          [value]="true"
          formControlName="actif"
          [disabled]="!canModify()">
        </dx-check-box>
      </div>
    </div>

    <!-- Intégrer le form specifique à Elap Finance - Affiché uniquement si le provider séléctionné est ELAP_FINANCE-->
    <div *ngIf="isGefProviderSelected(GEF_PROVIDER.ELAP_FINANCE)">

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Code Etablissement">Code Etablissement</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="codeEtablissement"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="Nom Client">Nom du client</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="nomClient"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Access Token">Token</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="accessToken"
              [mode]="!canModify() ? 'password' : 'text'"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="Code ELAP de l'article Frais de port">Code Frais de port</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="codeArticleFraisPort"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
      </div>


      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Dispo Achat">Dispo Achat</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="dispoAchat"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="Compte Contrepartie">Compte Contrepartie</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="compteContrepartie"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Compte Charge">Compte Charge</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="compteCharge"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="Compte FNP">Compte FNP</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="compteFNP"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Nature Achat">Nature Achat</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="natureAchat"
              [disabled]="!canModify()">
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="Destination Achat">Destination Achat</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="destinationAchat"
              [disabled]="!canModify()"
            >
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="WorkFlow Etape Initiale EJ">WfEtapeInitiale EJ</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="EJwfEtapeInitiale"
              [disabled]="!canModify()"
            >
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="WorkFlow Transistion EJ">WfTransition EJ</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="EJwfTransition"
              [disabled]="!canModify()"
            >
            </dx-text-box>
          </div>
        </div>
      </div>
      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="WorkFlow Etape Initiale SF">WfEtapeInitiale SF</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="SFwfEtapeInitiale"
              [disabled]="!canModify()"
            >
            </dx-text-box>
          </div>
        </div>
        <div class="dialog-line">
          <div class="label" title="WorkFlow Transistion SF">WfTransition SF</div>
          <div class="value">
            <dx-text-box
              class="inputfield"
              formControlName="SFwfTransition"
              [disabled]="!canModify()"
            >
            </dx-text-box>
          </div>
        </div>
      </div>

      <div class="dialog-line">
        <div class="dialog-line">
          <div class="label" title="Statut des bons de commandes à exporter">Statut bons cf <span
            class="danger-color">*</span></div>
          <div class="value">
            <yo-lookup
              #bonCfStatutExportLookup
              [data]="bonCfStatutExportlist"
              [selectedItem]="idSelectedBonCfStatutExport"
              autoSelect="false"
              (onValueChange)="onChangeBonCfStatutExport($event)"
              [disabled]="!canModify()"
            ></yo-lookup>
          </div>
        </div>
        <div class="dialog-line"></div>
      </div>
    </div>


    <!-- Intégrer le form specifique à DOL_API - Affiché uniquement si le provider séléctionné est DOL_API-->
    <div *ngIf="isGefProviderSelected(GEF_PROVIDER.DOL_API)">

      <div class="title-gef" title="Codes à renseigner">Import des fournisseurs</div>
      <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Secteurs par défauts">Secteurs</div>
            <div class="value">
              <yo-tagbox
                [data]="secteurList"
                [selectedItems]="selectedSecteurs"
                (onValueChange)="onSelectedSecteursChange($event)"
                [disabled]="!canModify()"
              >
              </yo-tagbox>
            </div>
          </div>
          <div class="dialog-line">

          </div>
        </div>
      </div>

      <div class="title-gef" title="Codes à renseigner">Import des denrées</div>
      <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="UT de la denrée">UT</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUTDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Type Produit de la denrée">Type Produit</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeProduitDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Zone Stockage de la denrée">Zone Stockage</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeZoneStockageDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Type Appro de la denrée">Type Appro</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeApproDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Type Sortie de la denrée">Type Sortie</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeSortieDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Famille de la denrée">Famille</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeFamilleDenree"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>
      </div>

      <div class="title-gef" title="Codes à renseigner">Import des denrées déclinées</div>
      <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="UT de la denrée déclinée">UT</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUTDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Type Produit de la denrée déclinée">Type Produit</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeProduitDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Zone Stockage de la denrée déclinée">Zone Stockage</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeZoneStockageDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Type Appro de la denrée déclinée">Type Appro</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeApproDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Type Sortie de la denrée déclinée">Type Sortie</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeTypeSortieDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Déclinaison de la denrée déclinée">Déclinaison</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeDeclinaisonDenreeDeclinee"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>
      </div>

      <div class="title-gef" title="Codes à renseigner">Import des articles</div>
      <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Unité de commande de l'article">Unite Commande</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUniteCommandeArticle"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Unité de facturation de l'article">Unite Facturation</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUniteFacturationArticle"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>

        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="Unité de stockage de l'article">Unite Stockage</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUniteStockageArticle"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="Allergene de l'article">Allergene</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeAllergene"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>
      </div>

      <div class="title-gef" title="Codes à renseigner">Export des commandes</div>
        <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="UF Magasin">UF Magasin</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUFMagasin"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="UF Cuisine">UF Cuisine</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUFCuisine"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>
      </div>


      <div class="title-gef" title="Codes à renseigner">Export des réceptions</div>
        <div class="container-gef">
        <div class="dialog-line">
          <div class="dialog-line">
            <div class="label" title="UF Magasin">UF Magasin</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUFMagasinReceptions"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
          <div class="dialog-line">
            <div class="label" title="UF Cuisine">UF Cuisine</div>
            <div class="value">
              <dx-text-box
                class="inputfield"
                formControlName="codeUFCuisineReceptions"
                [disabled]="!canModify()">
              </dx-text-box>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="mt-2 custom-button-container-right">
      <yo-button
        type="submit"
        iconClass="fas fa-save"
        tooltip="Enregistrer"
        buttonClass="cta-success"
        (onClick)="save()"
        [hidden]="!canModify()">
      </yo-button>
      <yo-button
        buttonClass="cta-delete"
        (onClick)="closeDialog()"
        tooltip="Fermer"
        iconClass="fas fa-times">
      </yo-button>
    </div>
  </form>

</dx-popup>
